<template>
    <el-link 
    :type="typename"
    :underline="underline"
    :disabled="disabled"    
    :icon="icon"
    @click.native="hrefBack?hrefBack(linkhref): null"
     >{{ linktitle }}</el-link>    
</template>

<script>
export default {
    name:'l-linkable',
    props: {
        linktitle: {
            type: String,
            defualt: '默认'
        },
        typename:String,
        underline:{
            type: Boolean,
            default: false
        },
        disabled:{
            type: Boolean,
            default: false
        },
        linkhref:String,
        icon:String,
        hrefBack: Function
    },
    watch: {
        value:{
            handler(newVal){
                if(this.$validatenull(newVal)){
                    
                }
            },
            immediate: true
        }
    },
    data () {
        return {
        }
    }
}
</script>